import React from "react";

export default function AButton(props) {
    let {onClick} = props;

    let _onClick = (e) => {
        e.preventDefault();
        if (onClick) {
            onClick();
        }
    };

    return <a
        {...props}
        href="#"
        onClick={_onClick}
        style={{display: "inline-block", padding: '4px 8px', width: 'auto', margin: 3}}
        className="btn btn-sm"

    >
        {props.children}
    </a>
}